export default __webpack_public_path__ + "static/media/date_range.7bf3c0c6.svg";